import { FiDownload } from "react-icons/fi";
import Tooltip from "../Tooltip/Tooltip";
import './SourceImage.scss';

function SourceImage({data}) {
  return (
      <div className="image image-holder">
        <Tooltip isPopover={false}>
          <img key={data.src} src={data.src} alt={data.alt} />
          <><a className="download" href={data.fits}>
            <FiDownload style={{ width: "20px", height: "20px", color: "#fff" }} />
          </a></>
        </Tooltip>
        <label>{data.label}</label>
      </div>
  );
}

export default SourceImage;
